import React, { useState, useEffect } from "react";
import ApiConfig from "../common/config/ApiConfig";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import LoadingComponent from "./LoadingComponent"; // Replace with the correct path
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BadgeIcon from "@mui/icons-material/Badge";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import styled from "@mui/system/styled";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";

function Profile() {
  const { t } = useTranslation();
  const user = localStorage.getItem("user");
  const [loading, setLoading] = useState(true); // Loading state
  const json = { user: user };
  const [profile, setProfile] = useState();

  useEffect(() => {
    ApiConfig.post("/profile", json).then((result) => {
      setProfile(result.data);
      setLoading(false);
    });
    // eslint-disable-next-line
  }, []);

  const Item = styled("div")(() => ({
    backgroundColor: "#fff",
    border: "1px solid #d9ebff",
    padding: "10px 14px",
    borderRadius: "10px",
    textAlign: "left",
    fontWeight: 700,
    color: "#062252",
    boxShadow: "0 1px 3px rgba(6, 34, 82, 0.08)",
  }));

  const fields = [
    {
      icon: <BadgeIcon fontSize="small" />,
      label: t("profile.fields.fullName"),
      value:
        profile && `${profile.f_name ?? ""} ${profile.l_name ?? ""}`.trim(),
    },
    {
      icon: <PermContactCalendarIcon fontSize="small" />,
      label: t("profile.fields.username"),
      value: profile && profile.Username,
    },
    {
      icon: <PhoneIphoneIcon fontSize="small" />,
      label: t("profile.fields.phone"),
      value: profile && profile.phone,
    },
    {
      icon: <AccountBalanceIcon fontSize="small" />,
      label: t("profile.fields.bank"),
      value: profile && profile.bank,
    },
    {
      icon: <AccountBalanceWalletIcon fontSize="small" />,
      label: t("profile.fields.bankAccount"),
      value: profile && profile.bankaccoutnumber,
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="flex flex-col w-[100%] h-[auto] justify-center"
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="flex flex-col justify-center">
          <div className="w-[100%] flex flex-row items-center h-[44px] p-2 px-4 bg-gradient-to-r from-brand-blue-800 via-brand-blue-700 to-brand-blue-800 border-b border-brand-gold-300/40 space-x-2 rounded-t-lg shadow-card">
            <AccountCircleIcon className="text-brand-gold-300" fontSize="small" />
            <span className="text-brand-gold-200 font-bold font-heading text-m tracking-wide">
              {t("profile.header")}
            </span>
          </div>
          <div className="flex flex-row justify-center bg-gradient-to-br from-brand-blue-50 via-white to-brand-blue-100 p-3 w-[100%] h-[auto] shadow-inner">
            {loading ? (
              <LoadingComponent />
            ) : (
              <div className="w-[100%] bg-white rounded-xl shadow-md overflow-hidden">
                <Box className="p-4">
                  <Box className="flex items-center gap-2 pb-3 mb-3 border-b border-brand-blue-100">
                    <div className="flex items-center justify-center w-9 h-9 rounded-full bg-gradient-to-br from-brand-blue-600 to-brand-blue-800 text-white shadow-sm">
                      <AccountCircleIcon fontSize="small" />
                    </div>
                    <Typography className="font-bold text-left text-slate-800">
                      {t("profile.cardTitle")}
                    </Typography>
                  </Box>
                  <Grid container spacing={2}>
                    {fields.map((field) => (
                      <React.Fragment key={field.label}>
                        <Grid item xs={12} sm={5} md={4}>
                          <div className="flex items-center gap-2 text-slate-600 font-semibold h-full">
                            <span className="flex items-center justify-center w-7 h-7 rounded-full bg-brand-blue-100 text-brand-blue-700">
                              {field.icon}
                            </span>
                            {field.label} :
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={7} md={8}>
                          <Item>{field.value}</Item>
                        </Grid>
                      </React.Fragment>
                    ))}
                  </Grid>
                </Box>
              </div>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Profile;
